import Link from 'next/link';
import Icon from '../Icon';
import { MouseEventHandler } from 'react';

export const CtaButton = (Props: {
  icon: string;
  children: JSX.Element;
  onClick?: MouseEventHandler;
  href?: string;
  dataTestId?: string;
}) => {
  return (
    <button
      data-testid={Props.dataTestId || ''}
      className="relative focus:outline-none focus-visible:ring-2 focus-visible:ring-darkGold focus-visible:ring-offset-2 rounded-full"
      type="button"
      onClick={Props.onClick}
    >
      <div
        className={`flex bg-redThree px-5 h-[42px] items-center leading justify-center rounded-full gap-1 outline-2 outline-darkGold`}
      >
        <div aria-hidden className="">
          <Icon type={Props.icon} className="text-darkGold" />
        </div>
        {Props.href ? (
          <Link
            target="_blank"
            href={Props.href}
            className="text-center font-medium text-[0.875rem] leading text-white"
          >
            {Props.children}
          </Link>
        ) : (
          <span className="text-center font-medium text-[0.875rem] leading text-white">
            {Props.children}
          </span>
        )}
      </div>
    </button>
  );
};

export default CtaButton;
